<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div v-if="items != null">
    <EditDialog
      v-model="editDialog"
      save-button-text="Save"
      :title="$t('editRole')"
      @save="loadItems()"
    >
      <template v-slot:form="{ onSave, onError, needSave, needReset }">
        <RoleForm
          :project-id="projectId"
          :item-id="itemId"
          @save="onSave"
          @error="onError"
          :need-save="needSave"
          :need-reset="needReset"
          :is-admin="true"
        />
      </template>
    </EditDialog>

    <YesNoDialog
      :title="$t('deleteRole')"
      :text="$t('askDeleteRole')"
      v-model="deleteItemDialog"
      @yes="deleteItem(itemId)"
    />

    <YesNoDialog
      :title="$t('deleteN', { count: selectedItems.length })"
      :text="$t('bulkDeleteConfirm', { count: selectedItems.length })"
      v-model="bulkDeleteDialog"
      @yes="bulkDelete()"
    />

    <v-toolbar flat>
      <v-btn icon class="mr-4" @click="returnToProjects()">
        <ZpIcon name="arrow-left" :size="20" />
      </v-btn>
      <v-toolbar-title>{{ $t('Roles') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <ListToolbar
        :value="searchText"
        :selection-count="selectedItems.length"
        @search="onSearchInput($event)"
        @bulk-delete="askBulkDelete()"
        class="mr-3"
      />
      <v-btn
        v-if="can(USER_PERMISSIONS.manageProjectResources)"
        :disabled="!premiumFeatures.custom_roles_management"
        color="primary"
        @click="editItem('new')"
        >{{ $t('newRole') }}</v-btn
      >
    </v-toolbar>

    <TeamMenu v-if="projectId" :project-id="projectId" :system-info="systemInfo" />

    <v-divider style="margin-top: -1px" />

    <v-alert
      v-if="!premiumFeatures.custom_roles_management"
      text
      color="amber darken-3"
      class="PageAlert"
    >
      <span class="mr-1" v-html="$t('roles_only_enterprise')"></span>

      <v-btn
        dark
        depressed
        v-if="isAdmin"
        color="amber darken-3"
        href="https://semaphoreui.com/enterprise"
        target="_blank"
      >
        {{ $t('upgrade_to_pro') }}
      </v-btn>

      <span v-else style="font-weight: bold">
        {{ $t('contact_admin_to_upgrade_enterprise') }}
      </span>
    </v-alert>

    <v-data-table
      v-model="selectedItems"
      show-select
      item-key="slug"
      :headers="headers"
      :items="items"
      :search="searchText"
      :custom-filter="filterByName"
      class="mt-4"
      :items-per-page="25"
      :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }"
      :no-data-text="searchText ? $t('noMatches') : $t('noItems')"
    >
      <template v-slot:item.permissions="{ item }">
        <TemplatePermissionsChips class="py-1" :permissions="item.permissions" />
      </template>
      <template v-slot:item.actions="{ item }">
        <div style="white-space: nowrap">
          <v-btn icon class="mr-1" @click="askDeleteItem(item.slug)">
            <ZpIcon name="trash-2" :size="18" />
          </v-btn>

          <v-btn icon class="mr-1" @click="editItem(item.slug)">
            <ZpIcon name="pencil" :size="18" />
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import EventBus from '@/event-bus';
import YesNoDialog from '@/components/YesNoDialog.vue';
import ItemListPageBase from '@/components/ItemListPageBase';
import EditDialog from '@/components/EditDialog.vue';
import RoleForm from '@/components/EditRoleForm.vue';
import TeamMenu from '@/components/TeamMenu.vue';
import TemplatePermissionsChips from '@/components/TemplatePermissionsChips.vue';
import ListToolbar from '@/components/ListToolbar.vue';

export default {
  mixins: [ItemListPageBase],

  props: {
    premiumFeatures: Object,
    projectId: Number,
    systemInfo: Object,
  },

  components: {
    TeamMenu,
    YesNoDialog,
    RoleForm,
    EditDialog,
    TemplatePermissionsChips,
    ListToolbar,
  },

  data() {
    return {};
  },

  computed: {
    IDFieldName() {
      return 'slug';
    },
  },

  watch: {
    async projectId() {
      await this.loadItems();
    },
  },

  methods: {
    getHeaders() {
      return [
        {
          text: this.$i18n.t('name'),
          value: 'name',
          width: '50%',
        },
        {
          text: this.$i18n.t('permissions'),
          value: 'permissions',
        },
        {
          text: this.$i18n.t('actions'),
          value: 'actions',
          sortable: false,
        },
      ];
    },

    async returnToProjects() {
      EventBus.$emit('i-open-last-project');
    },

    getItemsUrl() {
      return this.projectId ? `/api/project/${this.projectId}/roles` : '/api/roles';
    },

    getSingleItemUrl() {
      return this.projectId
        ? `/api/project/${this.projectId}/roles/${this.itemId}`
        : `/api/roles/${this.itemId}`;
    },

    getEventName() {
      return 'i-role';
    },
  },
};
</script>
